export default __webpack_public_path__ + "static/section_2-21f7934e162b70a8156c30eeb04444c8.png";